const ACCOUNTS_API_ROOT = `${process.env.API}/accounts`;
const PORTAL_API_ROOT = `${process.env.API}/developer-portal`;
const RIDB_API_ROOT = `${process.env.RIDB_ROOT}/api/v1`;

// ----------------------------------------------------------------------------
// R1S Endpoints

// Accounts
export const loginEndpoint = () => `${ACCOUNTS_API_ROOT}/login`;

// ----------------------------------------------------------------------------
// Developer Portal Endpoints

// Keys
export const keysEndpoint = () => `${PORTAL_API_ROOT}/api_keys`;
export const keyEndpoint = (id) => `${PORTAL_API_ROOT}/api_keys/${id}`;

// Organizations
export const orgsEndpoint = () => `${PORTAL_API_ROOT}/organizations`;

// Assets
export const assetsEndpoint = () => `${PORTAL_API_ROOT}/assets`;

// Activities
export const activitiesEndpoint = () => `${PORTAL_API_ROOT}/activities`;

// ----------------------------------------------------------------------------
// API Endpoints

function typeToAsset(type) {
  switch (type) {
    case 'facilities':
    case 'facility':
      return 'facilities';
    case 'recareas':
    case 'recarea':
      return 'recareas';
    default:
      return 'asset';
  }
}

// RecArea or Facility
export const assetApiEndpoint = (type, id) => `${RIDB_API_ROOT}/${typeToAsset(type)}/${id}`;

// Events
export const eventApiEndpoint = (assetType, assetId, eventId) => {
  const idComponent = eventId ? `/${eventId}` : "";
  return `${RIDB_API_ROOT}/${typeToAsset(assetType)}/${assetId}/events${idComponent}`;
};

// Accounts
export const accountEndpoint = () => `${PORTAL_API_ROOT}/internal/accounts`;
export const accountEndpointWithId = (id) => `${PORTAL_API_ROOT}/internal/accounts/${encodeURIComponent(id)}`;

// Generic API call
export const api = (url) => `${RIDB_API_ROOT}${url}`;
